import styled from "styled-components/macro";
import { ShiftSegment } from "types/types";
import {
  useDashboardPageContext,
  useFormatZoned,
  useSelectedShift,
} from "utils/customHooks/genericHooks";
import { Button } from "@mui/material";
import { goToShift } from "providers/GlobalStateProvider";
import { useSettings } from "contexts/SettingsManager/SettingsManager";
import { useDispatch } from "react-redux";
import { useTimeZoneMsOffset } from "utils/timeZoneHooks";
import { useDrag } from "react-use-gesture";
import { BREAKPOINT_TABLET } from "constants/constants";
import { useTransition } from "react";
import { SERVER_NAMES } from "components/Nav/Drawers/RightDrawer/FlightDebugger/SERVER_NAMES";

export function ShiftButtons({ shifts }) {
  return (
    <ShiftButtonsStyles>
      {shifts.map(shift => (
        <ShiftButton
          key={shift.range.ge}
          {...{
            shift,
          }}
        />
      ))}
    </ShiftButtonsStyles>
  );
}
const ShiftButtonsStyles = styled.div`
  display: flex;
  margin-right: 4px;
`;

function ShiftButton({ shift }: { shift: ShiftSegment }) {
  const selectedShift = useSelectedShift();
  const formatZoned = useFormatZoned();
  const { isFullDaySelected, setIsFullDaySelected } = useDashboardPageContext();
  const { dayStartMsOffset } = useSettings();

  const isSelectedShift =
    !isFullDaySelected &&
    selectedShift &&
    Number(selectedShift.range.ge) === Number(shift.range.ge);
  const isFutureShift = shift.range.ge > Date.now();

  const dispatch = useDispatch();
  const timeZoneMsOffset = useTimeZoneMsOffset();
  const [isPending, startTransition] = useTransition();
  const handleGoToShift = () => {
    startTransition(() => {
      if (isFullDaySelected) {
        setIsFullDaySelected(false);
      }
      dispatch(
        goToShift(shift, dayStartMsOffset, timeZoneMsOffset, formatZoned)
      );
    });
  };

  /** prevent mouseUp after dragging from triggering click */
  const bind = useDrag(({ tap }) => {
    if (tap) {
      handleGoToShift();
    }
  });
  const showWeekday = window.innerWidth >= BREAKPOINT_TABLET;
  return (
    <Button
      data-testid={`shift-button-name-${shift.shift.name
        ?.split(" ")
        .join("_")}-ge-${shift.range.ge}`}
      data-server-names={[SERVER_NAMES.askrShifts]}
      disabled={isSelectedShift || isFutureShift || isPending}
      className={`shiftButton ${isSelectedShift ? "active" : ""} ${
        isFutureShift ? "future" : ""
      }`}
      style={{ cursor: isPending ? "wait" : "pointer" }}
      {...bind()}
    >
      <div className="rangeName">{shift.shift.name}</div>
      <div className="range">
        {formatZoned(shift.range.ge, `${showWeekday ? "E " : ""}HH:mm`) +
          " - " +
          formatZoned(shift.range.lt, `${showWeekday ? "E " : ""}HH:mm`)}
      </div>
    </Button>
  );
}
